import styled from 'styled-components'

export const SimpleGrid = styled.div`
    display: grid;
    gap: ${(props) => props.gap};
    grid-gap: ${(props) => props.gap};
    grid-template-columns: repeat(auto-fill, ${(props) => props.width});
    justify-content: center;
    align-items: center;
`